module.exports = __webpack_public_path__ + "img/discount.478e2986.svg";